import { TextAssist } from '../comments/TextAssist';
import { useState } from 'react';
import type { V2ChecklistItem } from '../../domain/inspection';
import { useT } from '../../i18n/i18n';
import { setItemNoteAction } from '../../state/inspectionStore';
import { Button, SheetShell, TextArea } from '../../ui/components';
import { itemTitleFor } from '../../i18n/labels';

// "评语" from the checklist card (task book §9 / §10): the inspector's own note on an item, in a
// bottom sheet with Cancel — no need to open the full item workspace for one sentence. The note
// never becomes a finding by itself (Authority §9.2).
export function ItemNoteSheet(props: { item: V2ChecklistItem; onClose: () => void }) {
  const { t, locale } = useT();
  const [value, setValue] = useState(props.item.inspectorNote);
  const [busy, setBusy] = useState(false);

  async function save() {
    setBusy(true);
    try {
      await setItemNoteAction(props.item.id, value);
      props.onClose();
    } finally {
      setBusy(false);
    }
  }

  return (
    <SheetShell
      title={t('item.inspectorNote')}
      subtitle={itemTitleFor(locale, props.item)}
      onClose={props.onClose}
      layer="over"
      testId="item-note-sheet"
      footer={
        <>
          <Button onClick={() => void save()} disabled={busy} testId="item-note-save">
            {t('common.save')}
          </Button>
          <Button variant="text" onClick={props.onClose} testId="item-note-cancel">
            {t('shell.cancel')}
          </Button>
        </>
      }
    >
      <p className="card-note">{t('item.inspectorNoteHint')}</p>
      <TextArea id="item-note-input" value={value} onChange={setValue} placeholder={t('item.notePlaceholder')} rows={4} testId="item-note-input" />
      <TextAssist value={value} onChange={setValue} fieldId="item-note-input" lang={locale} testId="item-note-input-assist" />
    </SheetShell>
  );
}
